import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  shiftsAccessControl,
  csvHistoryAccessControl,
} from '../access-control/shiftsAccess.configuration'
import { useIsShiftManagementM2Enabled } from '../utils/roulette/useIsShiftManagementM2Enabled'

const LegacyShiftsListPage = lazy(
  () =>
    /* webpackChunkName: "LegacyShiftsPage" */
    import('../pages/legacy/list/ShiftsListPage')
)
const ShiftManagementPage = lazy(
  () =>
    /* webpackChunkName: "ShiftManagementPage" */
    import('../pages/ShiftManagement/page')
)
const CSVHistoryPage = lazy(
  () =>
    /* webpackChunkName: "CSVHistoryPage" */
    import('../pages/CSVHistory/page')
)
// @hygen:inject page-import

const ShiftsPageFeatureToggled = () => {
  const isShiftManagementM2Enabled = useIsShiftManagementM2Enabled()
  return isShiftManagementM2Enabled ? (
    <DomainRoute exact route="shifts" component={ShiftManagementPage} />
  ) : (
    <DomainRoute
      exact
      route="shifts"
      component={LegacyShiftsListPage}
      scopePicker={{
        titles: ['shiftsDomain.title'],
      }}
    />
  )
}

export const shiftsRouter = (
  <DomainRoute route="shifts" accessControl={shiftsAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="csvHistory"
        component={CSVHistoryPage}
        accessControl={csvHistoryAccessControl}
      />
      <ShiftsPageFeatureToggled />
      {/* @hygen:inject router-route 
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
